/* __next_internal_client_entry_do_not_use__ Popover auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { PopoverProvider, usePopoverContext } from "./PopoverContext";
/**
 * A wrapper component that renders a popover using Floating UI and portals.
 * The floating popover element must be defined as a child wrapped in PopoverContent.
 *
 * @example
 * <Popover open={isOpen}>
 *   <Button>Anchor Element</Button>
 *   <PopoverContent>
 *     <div>Popover Content</div>
 *   </PopoverContent>
 * </Popover>
 */ export var Popover = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(PopoverProvider, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx(PopoverBase, {
            children: children
        })
    }));
};
var PopoverBase = function(param) {
    var children = param.children;
    var _usePopoverContext = usePopoverContext(), anchorRef = _usePopoverContext.anchorRef, onKeyDown = _usePopoverContext.onKeyDown, floatingData = _usePopoverContext.floatingData, floatingInteractions = _usePopoverContext.floatingInteractions, className = _usePopoverContext.className;
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: !anchorRef ? floatingData.refs.setReference : undefined
    }, floatingInteractions.getReferenceProps()), {
        className: className,
        onKeyDown: onKeyDown,
        children: children
    }));
};
